import axios from 'axios';
import { useState, useEffect } from 'react'; 
import Carousel from 'react-material-ui-carousel'
import { model, gtechurl, fblink } from '../config/config';
import { Button, Typography } from '@mui/material'
import ContentModal from './ContentModal';


function Slide(props) {
 /* return (
    <div className='slide' style={{ backgroundImage: `url(${props.fileid ? `${gtechurl}${model}/images/${model}_{props.fileid}.gif` : unavailableLandscape})` }}>
      <div className='slide__cover'>
      <Typography variant="h4" noWrap={true}>{props.name || props.name}</Typography>
      <ContentModal binfile={props.binfile} fileid={props.fileid}>
        <Button variant="contained">
        { discover {props.media_type === 'tv' ? 'tv show' : 'movie'} }
        Show more
        </Button>
      </ContentModal>
      </div>

    </div>
  )*/
}

export default function Slider(props) {
  const [content, setContent] = useState([]);
  const fetchData = async () => {
    const { data } = await axios.get(`${fblink}/watchface/${model}.json?orderBy="$key"&limitToFirst=11`);
	let arrayOfObjects = Object.keys(data).map(key => {
		let ar = data[key]
		ar.key = key
		return ar})
    setContent(arrayOfObjects);
  }
  useEffect(() => {
   // fetchData();
    // eslint-disable-next-line
  }, [])

  return (
    <Carousel indicators={false} navButtonsAlwaysVisible swipe
    navButtonsProps={{
      style: {
          backgroundColor: 'rgba(0,0,0,0.4)',
          color: 'white',
      }
  }}
    >
      {
        content && content.slice(0, 10).map(item => (
          <Slide key={item.fileid}
            {...item}
          ></Slide>
        ))
      }
    </Carousel>
  )
}

